<input
  type="file"
  #file
  style="display: none"
  id="fileToUpload"
  [accept]="acceptedTypes"
  (change)="fileChangeEvent($event)"
/>
<div
  [ngClass]="{ 'file-box-btn': !previewImageUrl }"
  class="file-box"
  (click)="fileBoxHandler()"
>
  <div
    *ngIf="!previewImageUrl"
    class="full-height"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <div class="button-container" *ngIf="!isLoading">
      <img [src]="checkCardSide()" alt="Id" />
      <span [innerHTML]="label" class="label-wrapper"></span>
    </div>
    <div *ngIf="isLoading">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="40"
        strokeWidth="3"
      ></mat-progress-spinner>
    </div>
  </div>

  <div
    *ngIf="!loaderService.isActive && previewImageUrl"
    class="full-height"
    fxLayout="column"
    fxLayoutAlign="space-around center"
  >
    <img [src]="previewImageUrl" accept="image/*" class="preview-image" />
    <button mat-button type="button" color="primary" (click)="addFiles()">
      <mat-icon>autorenew</mat-icon>
      <span>{{ 'common.update' | translate }}</span>
    </button>
    <div class="error-hint-text">
      <mat-error *ngIf="error" class="error-label">{{ error }}</mat-error>
      <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    </div>
  </div>
</div>
